module.exports = __webpack_public_path__ + "img/gateway.bf477aee.svg";